// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sx6xiep2QQ5uj1B7YOiA{padding:16px 0 14px}.Sx6xiep2QQ5uj1B7YOiA .Fb9jkQ01cTxPXg0gvpps{justify-content:flex-start;align-items:center;margin-bottom:16px;display:flex}.Sx6xiep2QQ5uj1B7YOiA .Fb9jkQ01cTxPXg0gvpps:last-child{margin-bottom:0}.Sx6xiep2QQ5uj1B7YOiA .Fb9jkQ01cTxPXg0gvpps .vKhBC2HFu0UAMN8VUHfW{margin:0 8px 0 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `Sx6xiep2QQ5uj1B7YOiA`,
	"actionsRow": `Fb9jkQ01cTxPXg0gvpps`,
	"action": `vKhBC2HFu0UAMN8VUHfW`
};
export default ___CSS_LOADER_EXPORT___;
